"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSvgIconStyles = exports.svgIconVars = exports.svgIconCommonProps = exports.CUSTOM_SIZE = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var CUSTOM_SIZE = exports.CUSTOM_SIZE = "customSize";
var svgIconCommonProps = exports.svgIconCommonProps = _commonProps.defaultCommonProps;
var svgIconVars = exports.svgIconVars = (0, _initVars.default)({
  applied: svgIconCommonProps,
  variables: [{
    key: "rootTransform"
  }, {
    key: "iconSize"
  }, {
    key: "iconFill",
    canHaveColor: true
  }]
});
var sizeStyle = function sizeStyle(size, theme) {
  return {
    minWidth: theme.iconSizes[size],
    minHeight: theme.iconSizes[size],
    width: theme.iconSizes[size],
    height: theme.iconSizes[size]
  };
};
var styles = function styles(theme) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    variables: svgIconVars.styles,
    root: {
      flexShrink: 0,
      boxSizing: "content-box",
      transform: svgIconVars.get("rootTransform"),
      display: "inline-block",
      verticalAlign: "middle"
    },
    small: sizeStyle("small", theme),
    medium: sizeStyle("medium", theme),
    large: sizeStyle("large", theme)
  }, CUSTOM_SIZE, {
    minWidth: svgIconVars.get("iconSize"),
    minHeight: svgIconVars.get("iconSize"),
    width: svgIconVars.get("iconSize"),
    height: svgIconVars.get("iconSize")
  }), "dropShadow", {
    filter: "drop-shadow(0.4px 1px 1px rgba(0, 0, 0, 0.4))"
  }), "default", {
    fill: theme.colors.baseInvariant
  }), "primary", {
    fill: theme.colors.primary
  }), "highContrast", {
    fill: theme.colors.baseContrast100
  }), "warning", {
    fill: theme.colors.warning
  }), "error", {
    fill: theme.colors.alert
  }), "success", {
    fill: theme.colors.success
  }), "fill", {
    fill: svgIconVars.get("iconFill")
  });
};
var useSvgIconStyles = exports.useSvgIconStyles = (0, _createUseStyles.default)(styles, {
  name: "SvgIcon"
});